import { useOutletContext } from 'react-router-dom'

import { EmployeeSelectorV2ItemsDocument } from 'generated/resources/graphql'

import Chip from 'modules/core/components/Filter/base/Chip'
import Content from 'modules/core/components/Filter/base/Content'
import Provider from 'modules/core/components/Filter/base/Provider'
import { useQuery } from 'modules/core/hooks/useQuery'
import { getEmployeeDisplayName } from 'modules/core/lib/employeeName'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import {
  isManagerFilterVisible,
  useFilter,
} from 'modules/performance_process/components/review/show/Filters/context'
import { ReviewOverviewOutletContext } from 'modules/performance_process/pages/reviews/show/overview'

export const ManagerFilter = () => {
  const { reviewProcess } = useOutletContext<ReviewOverviewOutletContext>()
  const { value, setValue } = useFilter('managerId')
  const { setValue: setOnlyDirectReports } = useFilter('onlyDirectReports')

  const { data: selectedManagerData } = useQuery(EmployeeSelectorV2ItemsDocument, {
    variables: {
      ids: value ? [value] : [],
    },
    skip: !value,
  })

  const selectedManager =
    selectedManagerData?.employees.employeesConnection.nodes?.[0]?.employeeName

  if (!isManagerFilterVisible(reviewProcess)) {
    return null
  }

  return (
    <EmployeeSelectorV2
      label={i18n.t('common.manager')}
      value={value ?? undefined}
      onChange={(id) => {
        if (id) {
          setOnlyDirectReports(true)
          setValue(id)
          return
        }
        setOnlyDirectReports(false)
        setValue(null)
      }}
      options={{
        disableSelectAll: true,
      }}
      forcedFilters={{
        employeeIds: reviewProcess.targetManager.map((manager) => Number(manager.id)),
      }}
    >
      <Provider value={value} onValueChange={() => null} defaultOpen={false} closeOnChange>
        <Chip.Toggler
          active={!!value}
          label={i18n.t('common.manager')}
          activeLabel={
            value && selectedManager
              ? getEmployeeDisplayName({
                  fullName: selectedManager.fullName,
                  lastName: selectedManager.lastName,
                  preferredName: selectedManager.preferredName,
                })
              : '...'
          }
        />
        <Content maxWidth="s" maxHeight="s600" />
      </Provider>
    </EmployeeSelectorV2>
  )
}
